module.exports = require("react-sizeme");


//////////////////
// WEBPACK FOOTER
// external "react-sizeme"
// module id = 127
// module chunks = 0